import axios from 'axios'
import HTTP from './http'

export default {
    list: (params?: Record<string, any>) => axios.get(HTTP.APP_BENEFITS, { params }),
    create: (body: Record<string, any>) => axios.post(HTTP.APP_BENEFITS, body),
    update: (id: number | string, body: Record<string, any>) => axios.put(`${HTTP.APP_BENEFITS}/${id}`, body),
    delete: (id: number | string) => axios.delete(`${HTTP.APP_BENEFITS}/${id}`),
    reorder: (items: Array<{ id: number; sort_order: number }>) => axios.post(`${HTTP.APP_BENEFITS}/reorder`, { items })
}
